import { useState } from 'react';
import { CheckCircle2 } from 'lucide-react';
import { hasAcknowledged, saveAcknowledgement } from '../lib/brand';

export const useAcknowledgement = () => {
  const [acknowledged, setAck] = useState(hasAcknowledged);
  const acknowledge = () => { saveAcknowledgement(); setAck(true); };
  return { acknowledged, acknowledge };
};

export const AckGate = ({ acknowledged, onAcknowledge }) => {
  if (acknowledged) {
    return (
      <p className="flex items-center gap-1.5 text-[11px] text-zinc-600" data-testid="ack-confirmed">
        <CheckCircle2 className="w-3.5 h-3.5 text-brand" />
        Acknowledged on this device: descriptive data only, not financial advice.
      </p>
    );
  }
  return (
    <label className="flex items-start gap-3 cursor-pointer bg-zinc-900/40 border border-zinc-800/60 rounded-md p-3">
      <input
        type="checkbox"
        checked={false}
        onChange={(e) => e.target.checked && onAcknowledge()}
        className="mt-0.5 w-4 h-4 rounded border-zinc-600 bg-zinc-800 accent-brand flex-shrink-0"
        data-testid="compliance-checkbox"
      />
      <span className="text-xs text-zinc-500 leading-relaxed">
        I understand this tool provides <span className="text-zinc-300">descriptive market data only</span> and does not constitute financial advice.
      </span>
    </label>
  );
};
